function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/helpers/nonIterableSpread.js
// module id = 240
// module chunks = 1